import type { QueryParameter } from '../QueryParameterUtils';
import { Event } from '~/Features/Messaging/types';

export class QueryParametersChanged extends Event {
    public static readonly id = 'QueryParametersChanged';

    constructor(
        public queryParams: QueryParameter[],
        public storedInHistory: boolean
    ) {
        super(QueryParametersChanged.id);
    }
}
